import React, { Component } from 'react';

import classes from './LayerGroup.module.css';
import AnimateHeight from 'react-animate-height';

class LayerGroup extends Component {
    
    state={
        groupClosed: false,
        height: "auto"
    }

    toggleGroup = () => {
        const groupClosed = !this.state.groupClosed;
        let height = 0;
        if (this.state.height === 0) height = "auto";

        this.setState({groupClosed:groupClosed,height:height});
    }

    render () {
        let icon = <svg className={classes.GroupIcon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M216 23.86c0-23.8-30.65-32.77-44.15-13.04C48 191.85 224 200 224 288c0 35.63-29.11 64.46-64.85 63.99-35.17-.45-63.15-29.77-63.15-64.94v-85.51c0-21.7-26.47-32.23-41.43-16.5C27.8 213.16 0 261.33 0 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-170.29-168-193-168-296.14z"></path></svg>
                         
        if (this.props.icon === "admIcon"){
            icon = <svg className={classes.GroupIcon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M501.62 92.11L267.24 2.04a31.958 31.958 0 0 0-22.47 0L10.38 92.11A16.001 16.001 0 0 0 0 107.09V144c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-36.91c0-6.67-4.14-12.64-10.38-14.98zM64 192v160H48c-8.84 0-16 7.16-16 16v48h448v-48c0-8.84-7.16-16-16-16h-16V192h-64v160h-96V192h-64v160h-96V192H64zm432 256H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"></path></svg>
        } else if (this.props.icon === "clcIcon"){
            icon = <svg className={classes.GroupIcon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path></svg>
        }

        return(
            <div className={this.state.groupClosed ? [classes.LayerGroup, classes.Closed].join(' ') : classes.LayerGroup}>
                <div className={classes.LayerGroupTitleRow}>
                    {icon}
                    <h4>{this.props.groupName}</h4>
                    <div className={classes.ArrowWrapper}>
                    <svg onClick={this.toggleGroup} className={classes.CloseButton} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512"><path d="M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z"></path></svg>
                    </div>
                </div>
                <AnimateHeight
                    duration={ 500 }
                    height={ this.state.height } // see props documentation below
                >
                    <div className={classes.LayerGroupItems}>
                        {this.props.legendItems}
                    </div>
                </AnimateHeight>
            </div>
        )
    }
}

export default LayerGroup;